import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setCustomerDeliberately,
  removeCustomerDeliberately,
  setCustomerVehicleDeliberatelyType,
  setDeliberatelyFileContent,
  setStoreFileType,
  saveVisit,
} from '../../Actions/reducer'
import { IApplicationState } from 'Store/types'
import CaptureImage from 'Components/CaptureImage'
import { getUploadLink, uploadDeliberateliesFiles } from 'Application/Visits/Actions/action'
import Const from 'Utils/Consts'
import { IAutoPartModel } from 'Application/Visits/Actions/model'
import Icon from 'Components/Icon'
import { useSettings } from 'Contexts/SettingsContext'
import { format } from 'react-string-format'
import PodSpaceImage from 'Components/Image/PodSpaceImage'
import { useNetStatus } from 'Contexts/NetStatusContext'
import { DocumentQualityClassification } from 'assets/image_quality/document_quality_classification_helper/DocumentQualityClassification'

async function base64ToImageElement(base64: string): Promise<HTMLImageElement> {
  console.log('🔄 تبدیل Base64 به ImageElement...')
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = base64
    img.onload = () => {
      resolve(img)
    }
    img.onerror = err => {
      console.error(' خطا در لود تصویر:', err)
      reject(err)
    }
  })
}

export async function checkImageQuality(base64Image: string) {
  try {
    const quality_verification = await new DocumentQualityClassification()
    console.log(' DocumentQualityClassification ساخته شد')

    const imgElement = await base64ToImageElement(base64Image)
    if (!imgElement) {
      console.error(' تصویر نامعتبر است و نمی‌توان کیفیت را بررسی کرد')
      return { quality: 'unknown', error: 'Invalid image', confidence: 0 }
    }

    console.log(' در حال پردازش تصویر برای بررسی کیفیت...')

    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Timeout in quality check')), 15000),
    )

    const qualityPromise = quality_verification.processResult(imgElement, 0.0, false)

    const result = await Promise.race([qualityPromise, timeoutPromise])

    console.log(' نتیجه بررسی کیفیت تصویر:', result)

    return result
  } catch (error) {
    console.error(' خطا در بررسی کیفیت تصویر:', error)

    // برگرداندن مقدار پیش‌فرض در صورت خطا
    // return {
    //   quality: 'unknown',
    //   error: error.message,
    //   confidence: 0
    // };
  }
}

const ImageItem = (props: {
  name: string
  title: string
  isRequird: boolean
  isPodSpace: boolean
  data: IAutoPartModel | undefined
  onCapture: (image: string, fileType: string) => void
  onRemove: () => void
}) => {
  const [t] = useTranslation()
  const { settings } = useSettings()
  const imageMaxSize =
    settings?.REACT_APP_IMAGE_MAX_SIZE !== undefined
      ? settings?.REACT_APP_IMAGE_MAX_SIZE
      : Const.env.REACT_APP_IMAGE_MAX_SIZE
  const imageMaxSizeMb = imageMaxSize / 1024
  const checkAi =
    settings?.REACT_APP_CHECK_AI != undefined
      ? settings?.REACT_APP_CHECK_AI
      : Const.env.REACT_APP_CHECK_AI

  const { customerDeliberately } = useSelector((store: IApplicationState) => store.visits.newVisit)

  const [lastFileType, setLastFileType] = useState<'CAMERA' | 'FILE' | undefined>(undefined)
  const [imageMaxSizeError, setImageMaxSizeError] = useState<boolean>(false)
  const [isProcessing, setIsProcessing] = useState<boolean>(false)
  const dispatch = useDispatch()

  const handleSelect = () => {
    const fileInput = document.getElementById(`fileInput_${props.name}`)
    fileInput?.click()
  }

  const handleFileChange = (e: any) => {
    const file = e.target.files[0]
    if (file) {
      const fileSizeKB = Number(file.size / 1024)

      if (fileSizeKB <= imageMaxSize) {
        setImageMaxSizeError(false)

        const reader = new FileReader()

        reader.onloadend = async () => {
          const base64String = reader.result as string

          try {
            console.log(` شروع بررسی کیفیت تصویر برای ${props.name}...`)
            if (checkAi) {
              setIsProcessing(true)
              checkImageQuality(base64String)
                .then(qualityResult => {})
                .catch(qualityError => {
                  console.warn(` خطا در بررسی کیفیت ${props.name}:`, qualityError)
                })
                .finally(() => {
                  setIsProcessing(false)
                })
            }

            props.onCapture(base64String, file.type)
            setLastFileType('FILE')
          } catch (error) {
            console.error(` خطا در پردازش فایل ${props.name}:`, error)
            setIsProcessing(false)
          }
        }

        reader.onerror = error => {
          console.error(` خطا در خواندن فایل ${props.name}:`, error)
          setIsProcessing(false)
        }

        reader.readAsDataURL(file)
      } else {
        console.warn(` سایز فایل ${props.name} بیش از حد مجاز:`, {
          fileSizeKB,
          maxAllowed: imageMaxSize,
        })
        setImageMaxSizeError(true)
      }
    } else {
      console.log(` هیچ فایلی برای ${props.name} انتخاب نشد`)
    }
  }

  const handleCaptureFromCamera = async (image: string) => {
    try {
      if (checkAi) {
        setIsProcessing(true)
        checkImageQuality(image)
          .then(qualityResult => {
            console.log(` نتیجه کیفیت عکس دوربین ${props.name}:`, qualityResult)
          })
          .catch(qualityError => {
            console.warn(` خطا در بررسی کیفیت عکس دوربین ${props.name}:`, qualityError)
          })
          .finally(() => {
            setIsProcessing(false)
          })
      }

      setLastFileType('CAMERA')
      setImageMaxSizeError(false)
      props.onCapture(image, 'image/png')
    } catch (error) {
      console.error(` خطا در پردازش عکس دوربین ${props.name}:`, error)
      setIsProcessing(false)
    }
  }

  const handleRemoveImage = () => {
    console.log(` حذف تصویر ${props.name}`, {
      hadData: !!props.data,
      previousStatus: props.data?.status,
    })

    props.onRemove()
    setLastFileType(undefined)
  }

  return (
    <div
      className={`px-6 pb-6${customerDeliberately.loading && props.data?.status == 0 ? ' loading' : ''}${isProcessing ? ' processing' : ''}`}
    >
      <div className="text-sm mb-2">تصویر {t(props.title)} را ثبت کنید.</div>

      <PodSpaceImage
        isPodSpace={props.isPodSpace}
        className="bg-gray-300 rounded-xl h-[342px] w-full flex items-end p-4 bg-cover bg-no-repeat bg-center"
        hashFile={props.data?.hashFile}
        fileId={props.data?.fileId}
        fileContent={props.data?.image}
        onLoad={(image: string) => {
          console.log(`🖼️ تصویر ${props.name} در PodSpaceImage لود شد:`, {
            hasImage: !!image,
          })
          dispatch(setDeliberatelyFileContent({ id: props.data?.id, image }))
        }}
        styles={
          props.data
            ? {
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                border: '2px solid #00647F',
                borderRadius: '10px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                width: '100%',
                height: '342px',
              }
            : {
                width: '100%',
                height: '342px',
                backgroundColor: '#f0f0f0',
                border: '2px solid #00647F',
                borderRadius: '10px',
              }
        }
      >
        <div style={{ position: 'relative', height: '100%' }}>
          <span style={{ position: 'absolute', top: 0, right: 0 }}>
            {t(props.isRequird ? 'REQUIRD' : 'UN_REQUIRD')}
          </span>
          {Number(props.data?.status) === 1 && (
            <span style={{ position: 'absolute', top: 30 }}>{t('UPLOADED')}</span>
          )}
          {customerDeliberately.loading &&
            Number(props.data?.status) !== 1 &&
            Number(props.data?.uploadProgress) > 0 &&
            Number(props.data?.uploadProgress) < 100 && (
              <span style={{ position: 'absolute', top: 30 }}>
                {`%${Math.round(Number(props.data?.uploadProgress))}`}
              </span>
            )}
        </div>
        <div className="flex justify-between items-center gap-2 w-full">
          {props.data && lastFileType === 'FILE' && (
            <button
              className="btn btn-inherit btn-lg flex gap-2 items-center justify-center w-full"
              onClick={() => handleSelect()}
              style={{ paddingLeft: 0, paddingRight: 0 }}
              disabled={isProcessing}
            >
              <Icon name="document-download" className="w-6 h-6" />
              <input
                id={`fileInput_${props.name}`}
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleFileChange}
                disabled={isProcessing}
              />
              {t('AGAIN')}
            </button>
          )}
          {!customerDeliberately.loading && lastFileType !== 'FILE' && (
            <CaptureImage title={props.title} onCapture={handleCaptureFromCamera}>
              {props.data ? (
                <button
                  className="btn btn-inherit btn-lg flex gap-2 items-center justify-center w-full"
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                  disabled={isProcessing}
                >
                  <Icon name="camera" className="w-6 h-6" />
                  {t('AGAIN')}
                </button>
              ) : (
                <button
                  className="btn btn-primary btn-lg flex gap-2 items-center justify-center w-full"
                  disabled={isProcessing}
                >
                  <Icon name="camera" className="w-6 h-6" />
                  {t('FROM_CAMERA')}
                </button>
              )}
            </CaptureImage>
          )}
          {props.data ? (
            <button
              className="btn btn-error btn-lg flex gap-2 items-center justify-center w-full"
              onClick={handleRemoveImage}
              style={{ paddingLeft: 0, paddingRight: 0 }}
              disabled={isProcessing}
            >
              <Icon name="close-square" className="w-6 h-6" />
              {t('REMOVE')}
            </button>
          ) : (
            <button
              className="btn btn-inherit btn-lg flex gap-2 items-center justify-center w-full"
              onClick={() => handleSelect()}
              style={{ paddingLeft: 0, paddingRight: 0 }}
              disabled={isProcessing}
            >
              <Icon name="document-download" className="w-6 h-6" />
              <input
                id={`fileInput_${props.name}`}
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleFileChange}
                disabled={isProcessing}
              />
              {t('FROM_FILE')}
            </button>
          )}
        </div>
      </PodSpaceImage>
      {imageMaxSizeError && (
        <div
          id="alert-error"
          className="flex items-center p-3 text-white rounded-xl bg-gray-800 dark:bg-gray-800 mt-1"
          role="alert"
        >
          <div className="bg-error/[.16] text-error p-2 rounded-lg flex justify-center items-center">
            <Icon name="ic_error" className="w-6 h-6" />
          </div>
          <span className="sr-only">error</span>
          <div className="ms-3 text-sm font-semibold grow">
            {format(t('IMAGE_MAX_SIZE_LIMIT_MESSAGE'), imageMaxSizeMb)}
          </div>
        </div>
      )}
    </div>
  )
}

// export default ImageItem;

const GetDeliberatelyPage = (props: { handleNext: () => void }) => {
  const [t] = useTranslation()
  const { newVisit } = useSelector((store: IApplicationState) => store.visits)
  const { netStatus } = useNetStatus()
  const { settings } = useSettings()
  const dispatch = useDispatch()

  const uploadLinkSize =
    (settings?.REACT_APP_UPLOAD_LINK_SIZE ?? Const.env.REACT_APP_UPLOAD_LINK_SIZE) || 10200

  const onNextButtonClickHandle = () => {
    if (
      (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
        newVisit.customerDeliberately.vehicleCard &&
        newVisit.customerDeliberately.vehicleCardBack) ||
      (newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
        newVisit.customerDeliberately.vehicleDoc) ||
      (newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
        newVisit.customerDeliberately.vehicleCompanyDoc)
    ) {
      dispatch(setStoreFileType(newVisit.storeFileType))
      if (netStatus != 'MANUAL_OFF') {
        if (newVisit.storeFileType == 'POD_SPACE') {
          dispatch(
            getUploadLink({
              data: { sizeInKB: uploadLinkSize, visitId: 0, type: 1 },
              handleNext: props.handleNext,
            }),
          )
        } else {
          dispatch(uploadDeliberateliesFiles({ handleNext: props.handleNext }))
        }
      } else {
        dispatch(saveVisit())
        props.handleNext()
      }
    }
  }

  return (
    <React.Fragment>
      <div className="flex flex-col grow overflow-auto">
        <ImageItem
          name="nationalCard"
          title={t('NATIONAL_CARD_FRONT')}
          isRequird={false}
          isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
          data={newVisit.customerDeliberately.nationalCard}
          onCapture={(image: string, fileType: string) =>
            dispatch(
              setCustomerDeliberately({
                id: 1,
                image: image,
                fileType: fileType,
                status: 0,
                uploadProgress: 0,
              }),
            )
          }
          onRemove={() => dispatch(removeCustomerDeliberately(1))}
        />
        <ImageItem
          name="nationalCardBack"
          title={t('NATIONAL_CARD_BACK')}
          isRequird={false}
          isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
          data={newVisit.customerDeliberately.nationalCardBack}
          onCapture={(image: string, fileType: string) =>
            dispatch(
              setCustomerDeliberately({
                id: 2,
                image: image,
                fileType: fileType,
                status: 0,
                uploadProgress: 0,
              }),
            )
          }
          onRemove={() => dispatch(removeCustomerDeliberately(2))}
        />

        <div style={{ margin: '10px' }}>
          <h2>{t('VEHICLE_DELIBERATELY_TYPE')}</h2>
          <div className="" style={{ marginTop: '8px', marginBottom: '8px' }}>
            <div className="flex items-center me-4 mb-3">
              <input
                id="vehicleCardRadio"
                name="vehicleCardRadio"
                type="radio"
                value="CARD"
                checked={newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'}
                onChange={e => dispatch(setCustomerVehicleDeliberatelyType(e.currentTarget.value))}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                htmlFor="vehicleCardRadio"
                className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                style={{ marginRight: '8px' }}
              >
                {String(t('VEHICLE_CARD'))}
              </label>
            </div>
            <div className="flex items-center me-4 mb-3">
              <input
                id="vehicleDocRadio"
                name="vehicleDocRadio"
                type="radio"
                value="DOC"
                checked={newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'}
                onChange={e => dispatch(setCustomerVehicleDeliberatelyType(e.currentTarget.value))}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                htmlFor="vehicleDocRadio"
                className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                style={{ marginRight: '8px' }}
              >
                {String(t('VEHICLE_DOC'))}
              </label>
            </div>
            <div className="flex items-center me-4">
              <input
                id="vehicleCompanyRadio"
                name="vehicleCompanyRadio"
                type="radio"
                value="COMPANY_DOC"
                checked={newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'}
                onChange={e => dispatch(setCustomerVehicleDeliberatelyType(e.currentTarget.value))}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                htmlFor="vehicleCompanyRadio"
                className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                style={{ marginRight: '8px' }}
              >
                {String(t('VEHICLE_COMPANY_DOC'))}
              </label>
            </div>
          </div>
        </div>

        {newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' ? (
          <React.Fragment>
            <ImageItem
              name="vehicleCard"
              title={t('VEHICLE_CARD_FRONT')}
              isRequird={true}
              isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
              data={newVisit.customerDeliberately.vehicleCard}
              onCapture={(image: string, fileType: string) =>
                dispatch(
                  setCustomerDeliberately({
                    id: 3,
                    image: image,
                    fileType: fileType,
                    status: 0,
                    uploadProgress: 0,
                  }),
                )
              }
              onRemove={() => dispatch(removeCustomerDeliberately(3))}
            />
            <ImageItem
              name="vehicleCardBack"
              title={t('VEHICLE_CARD_BACK')}
              isRequird={true}
              isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
              data={newVisit.customerDeliberately.vehicleCardBack}
              onCapture={(image: string, fileType: string) =>
                dispatch(
                  setCustomerDeliberately({
                    id: 4,
                    image: image,
                    fileType: fileType,
                    status: 0,
                    uploadProgress: 0,
                  }),
                )
              }
              onRemove={() => dispatch(removeCustomerDeliberately(4))}
            />
          </React.Fragment>
        ) : newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' ? (
          <ImageItem
            name="vehicleDoc"
            title={t('VEHICLE_DOC')}
            isRequird={true}
            isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
            data={newVisit.customerDeliberately.vehicleDoc}
            onCapture={(image: string, fileType: string) =>
              dispatch(
                setCustomerDeliberately({
                  id: 5,
                  image: image,
                  fileType: fileType,
                  status: 0,
                  uploadProgress: 0,
                }),
              )
            }
            onRemove={() => dispatch(removeCustomerDeliberately(5))}
          />
        ) : (
          <ImageItem
            name="vehicleCompanyDoc"
            title={t('VEHICLE_COMPANY_DOC')}
            isRequird={true}
            isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
            data={newVisit.customerDeliberately.vehicleCompanyDoc}
            onCapture={(image: string, fileType: string) =>
              dispatch(
                setCustomerDeliberately({
                  id: 6,
                  image: image,
                  fileType: fileType,
                  status: 0,
                  uploadProgress: 0,
                }),
              )
            }
            onRemove={() => dispatch(removeCustomerDeliberately(6))}
          />
        )}
      </div>

      <div className="cta">
        <button
          className="btn btn-primary btn-lg flex items-center justify-center gap-2"
          disabled={
            newVisit.uploadLink.loading ||
            newVisit.customerDeliberately.loading ||
            Boolean(
              !(
                (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
                  newVisit.customerDeliberately.vehicleCard &&
                  newVisit.customerDeliberately.vehicleCardBack) ||
                (newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
                  newVisit.customerDeliberately.vehicleDoc) ||
                (newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
                  newVisit.customerDeliberately.vehicleCompanyDoc)
              ),
            )
          }
          onClick={onNextButtonClickHandle}
        >
          {t('NEXT')}
          <Icon name="arrow-left" className="w-6 h-6" />
        </button>
        <button
          className="btn btn-outline-primary btn-lg"
          onClick={() => {
            dispatch(setStoreFileType(newVisit.storeFileType))
            props.handleNext()
          }}
        >
          بعدا اضافه میکنم
        </button>
      </div>
    </React.Fragment>
  )
}

export default GetDeliberatelyPage
